<template>
    <div class="list">
        <NavBar></NavBar>
        <div>
            <van-button icon="search" size="small" round type="primary" @click="openInquiry">房屋查询</van-button>
        </div>
        <!-- <van-popup v-model:show="show" position="bottom" :style="{ height: '40%' }">
            <div>123</div>
        </van-popup> -->
        <van-action-sheet v-model:show="show" title="房屋查询" :style="{ height: '70%' }">
            <van-form @submit="onSubmit">
                <van-field v-model="username" name="用户名" placeholder="请输入交易业务编号" label="业务编号"  :rules="[{ required: true, message: '请填写用户名' }]" />
                <van-field readonly clickable name="picker" v-model="value1" label="选择小区"  :value="value1" placeholder="点击选择城市" @click="showPicker = true"  :rules="[{ required: true, message: '请选择小区' }]"/>
                <van-popup v-model:show="showPicker" position="bottom">
                    <van-picker :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
                </van-popup>
                <van-field v-model="password" type="password" name="密码" label="输入分区" placeholder="请输入分区(如无则不填)" />
                <van-field v-model="username" name="用户名" placeholder="请输入楼号" label="输入楼号" :rules="[{ required: true, message: '请填写用户名' }]" />
                <van-field v-model="username" name="用户名" placeholder="请输入单元号(如无则不填)" label="输入单元号" />
                <van-field v-model="username" name="用户名" placeholder="请输入楼层" label="输入楼层" :rules="[{ required: true, message: '请填写用户名' }]" />
                <van-field v-model="username" name="用户名" placeholder="请输入房间号" label="输入房间号"  :rules="[{ required: true, message: '请填写用户名' }]" />
                <div style="margin: 16px;">
                    <van-button round block type="danger" @click="openThis" native-type="submit">
                    立即查询
                    </van-button>
                </div>
            </van-form>
        </van-action-sheet>
        <!-- <van-dialog v-model="show" title="标题" show-cancel-button>
            <img src="https://img.yzcdn.cn/vant/apple-3.jpg" />
        </van-dialog>  -->
        <!-- <van-dialog v-model:show="show" title="标题" show-cancel-button>
            <img src="https://img.yzcdn.cn/vant/apple-3.jpg" />
        </van-dialog> -->
        <!-- <van-action-sheet v-model:show='show' title="标题">
            <div class="content">内容</div>
        </van-action-sheet> -->
        <!-- <van-overlay :show="show" @click="show = false" /> -->

    </div>
</template>

<script>
    // import Vue from 'vue';
    // import { Dialog } from 'vant';
    export default {
        // components:{
        //     [Dialog.Component.name]: Dialog.Component,
        // },
        data() {
            return {
                show: false,
                username:'',
                password:'',
                value1: '',
                columns: ['XXX小区', 'XXX小区', 'XXX小区', 'XXX小区', 'XXX小区'],
                showPicker: false,
            }
        },
        methods: {
            /**
             * 打开查询
             */
            openInquiry() {
                //  this.$notify('提示文案')
                this.show = true
                this.username = '';
                this.password = '';
                this.value1 = ''
                console.log(this.show)
                // this.$dialog.confirm({
                //     title: '标题',
                //     message: '弹窗内容',
                // })
            },
            onSubmit(values) {
                console.log('submit', values);
                this.show = false;
            },
            onConfirm(value) {
                console.log(value)
                this.value1 = value;
                console.log(this.value1)
                this.showPicker = false;
            },
        }
    }
</script>

<style scoped>
    .list {
        margin-top: 46px;
    }

    .content {
        padding: 16px 16px 160px;
    }
</style>